import React from "react"
import { Box, Container, useTheme, useMediaQuery } from "@mui/material"
import { deepmerge } from "@mui/utils"

import { AppNavigation as DefaultAppNavigation } from "containers/AppNavigation"
import { AppDesktopNavigation as DesktopNavigation } from "containers/DesktopNavigation"
import { IPageLayoutProps } from "./interface"
import { LegacyHeader } from "components/Header/LegacyHeader"

export const PageLayout: React.FC<IPageLayoutProps> = ({
  children,
  header = null,
  footer = null,
  AppNavigation = DefaultAppNavigation,
  sx = {},
  ...props
}) => {
  const theme = useTheme()
  const matchDownMd = useMediaQuery(theme.breakpoints.down("md"))
  const styleOverrides = theme.components[`AppPageLayout`]?.styleOverrides || {}
  const { root, container, navigationContainer, headerContainer } =
    styleOverrides

  AppNavigation = matchDownMd ? DefaultAppNavigation : DesktopNavigation

  return (
    <Box sx={deepmerge(root, sx)} {...props} data-name="PageLayout">
      <Box className="Header-Container" sx={headerContainer}>
        {header || <LegacyHeader />}
      </Box>

      <Container maxWidth="md" sx={container}>
        {children}
      </Container>

      <Box sx={navigationContainer}>
        <AppNavigation />
      </Box>
    </Box>
  )
}
